import styled, { keyframes } from 'styled-components';
import { darken } from 'polished';

import backgrond from '../../assets/sign-in_background.png';

export const Container = styled.div`
  height: 100vh;

  display: flex;
  align-items: stretch;
`;

export const Content = styled.div`
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;
  max-width: 700px;
`;

const apperFromLeft = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

export const AnimationContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  width: 100%;

  animation: ${apperFromLeft} 1s;

  > div {
    display: flex;
    flex-direction: column;

    padding-bottom: 15px;

    align-items: center;
    text-align: center;
    border-bottom: 1px solid #e6e6e6;

    img {
      margin-bottom: 30px;
    }

    span {
      font-weight: 300;
      color: #9e9e9e;
    }
  }

  form {
    margin: 40px;
    width: 340px;
    text-align: center;

    > a {
      margin-top: 20px;
      display: block;
      color: #021655;
      text-decoration: none;
      font-weight: 500;
      transition: all 0.2s ease-in-out;

      a:hover {
        color: ${darken(0.025, '#021655')};
      }
    }
  }

  aside {
    display: flex;
    flex-direction: column;
    align-items: center;

    span.contato {
      font-size: 16px;
      color: #808080;

      a {
        text-decoration: underline;
        color: #003399;
        font-weight: 700;
        transition: color 0.2s ease-in-out;

        &:hover {
          color: ${darken(0.025, '#021655')};
        }
      }
    }

    p {
      text-align: center;
      margin-top: 50px;
      font-size: 13px;
      color: #999999;

      strong {
        color: #003399;
      }

      span {
        display: block;
      }
    }
  }
`;

export const Background = styled.div`
  flex: 1;
  background: url(${backgrond}) no-repeat center;
  background-size: cover;
`;
